export const directDottedConstants = {
    GET_MEMBER_SUCCESS:'GET_MEMBER_SUCCESS',
    GET_MEMBER_FAIL:'GET_MEMBER_FAIL',

    SORT_USER_NAME:'SORT_USER_NAME',
    UPDATE_VELECITY_SUCCESS:'UPDATE_VELECITY_SUCCESS',
    UPDATE_VELECITY_FAIL:'UPDATE_VELECITY_FAIL',

    UPDATE_ACTIVE_TAB:'UPDATE_ACTIVE_TAB',
    
    GET_DIRECT_DOTED_OKR_SUCCESS:'GET_DIRECT_DOTED_OKR_SUCCESS',
    GET_DIRECT_DOTED_OKR_FAIL : 'GET_DIRECT_DOTED_OKR_FAIL',
    INITIAL_UPDATE_ACTIVE_TAB: 'INITIAL_UPDATE_ACTIVE_TAB'

    
} 

